import { useEffect, useRef } from 'react';

// Radix popovers dismiss on pointerdown/focusin in their OWN document. In an
// embedded form, a click on the host page happens in the parent document —
// the iframe only sees its window lose focus. Close on that too (also covers
// Tab-out and tab/app switches, like a native <select>). Issue #850.
//
// onClose is held in a ref so a new function identity per render (e.g. an
// inline arrow from the parent) does not re-subscribe the listener.
export default function useCloseOnWindowBlur(open, onClose) {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (!open) return undefined;
        const handleWindowBlur = (e) => {
            if (e.target !== window) return;
            onCloseRef.current?.();
        };
        window.addEventListener('blur', handleWindowBlur);
        return () => window.removeEventListener('blur', handleWindowBlur);
    }, [open]);
}
